export default __webpack_public_path__ + "static/media/password.a861cf39.svg";